(function () {
  if (Shopify.derm_custom === undefined) Shopify.derm_custom = {};

  Shopify.derm_custom.initializeSwiper = function (scope) {
    var rootScope = scope || document;
    var swiperRoots = rootScope.querySelectorAll("[data-swiper-root]");

    swiperRoots.forEach(function (root) {
      if (root.dataset.swiperInitialized === "true") return;

      var swiperContainer = root.classList.contains("swiper-container")
        ? root
        : root.querySelector(".swiper-container");

      var swiperPagination = root.querySelector(".swiper-pagination");
      var swiperNext = root.querySelector(".swiper-button-next");
      var swiperPrev = root.querySelector(".swiper-button-prev");
      var totalSlides = root.querySelectorAll(".swiper-slide").length;
      var configScript = root.querySelector("[data-swiper-config]");

      if (!swiperContainer || !window.Swiper) return;

      var swiperWrapper = swiperContainer.querySelector(
        ":scope > .swiper-wrapper"
      );

      if (!swiperWrapper) return;

      var config = {};

      if (configScript) {
        try {
          config = JSON.parse(configScript.textContent);
        } catch (error) {
          console.warn("Invalid swiper config JSON", error, root);
        }
      }

      var hasMultipleSlides = totalSlides > 1;

      var defaultConfig = {
        watchOverflow: true,
        loop: false,
        grabCursor: false
      };

      var mergedConfig = Object.assign({}, defaultConfig, config);

      mergedConfig.navigation =
        hasMultipleSlides && swiperNext && swiperPrev
          ? {
              nextEl: swiperNext,
              prevEl: swiperPrev
            }
          : false;

      mergedConfig.pagination =
        hasMultipleSlides && swiperPagination
          ? {
              el: swiperPagination,
              clickable: true,
              dynamicBullets: true
            }
          : false;

      if (!hasMultipleSlides) {
        mergedConfig.loop = false;
        mergedConfig.grabCursor = false;
      }

      new Swiper(swiperContainer, mergedConfig);

      root.dataset.swiperInitialized = "true";

      if (!hasMultipleSlides) {
        if (swiperPagination) swiperPagination.style.display = "none";
        if (swiperNext) swiperNext.style.display = "none";
        if (swiperPrev) swiperPrev.style.display = "none";
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    Shopify.derm_custom.initializeSwiper();
  });

  window.addEventListener("pageshow", function () {
    Shopify.derm_custom.initializeSwiper();
  });

  document.addEventListener("shopify:section:load", function (event) {
    Shopify.derm_custom.initializeSwiper(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var containers = event.target.querySelectorAll(".swiper-container");

    containers.forEach(function (container) {
      if (container.swiper) {
        container.swiper.destroy(true, true);
      }
    });

    var roots = event.target.querySelectorAll("[data-swiper-root]");
    roots.forEach(function (root) {
      delete root.dataset.swiperInitialized;
    });

    if (
      event.target.matches &&
      event.target.matches("[data-swiper-root]")
    ) {
      if (event.target.swiper) {
        event.target.swiper.destroy(true, true);
      }
      delete event.target.dataset.swiperInitialized;
    }
  });
})();
